<button type="submit" class="btn btn-help btn-block btn-lg mb-3" data-toggle="modal" data-target="#videoCallModal">
    {{'GetHelp' | translateOrgSpecific }}
  </button>

  <div class="modal fade" id="videoCallModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{'EnterInformation' | translateOrgSpecific }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <label>{{'EmailAddress' | translateOrgSpecific }}</label>
          <input [(ngModel)]="username" type="text" name="username" class="form-control form-control-lg" id="email" aria-describedby="emailHelp">

          <label>{{'Password' | translateOrgSpecific }} </label>
          <input [(ngModel)]="password" type="password" name="password" class="form-control form-control-lg" id="password">

          <label>{{'WhoToCallMessage' | translateOrgSpecific }} </label>
          <input [(ngModel)]="receiver" type="text" name="receiver" class="form-control form-control-lg" id="receiver">
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-apportis-secondary btn-block btn-md" data-dismiss="modal">
            {{'Close' | translateOrgSpecific }}
          </button>
          <button (click)="initCall()" type="button" class="btn btn-apportis-primary btn-block btn-md mb-2">
            {{'Call' | translateOrgSpecific }}
          </button>
        </div>
      </div>
    </div>
  </div>